document.querySelectorAll('.nav-btn').forEach(button => {
    button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-target');
        // 隐藏所有内容
        document.querySelectorAll('.nav-btn').forEach(content => {
        content.classList.remove('active');
        });

        document.querySelectorAll('.hid').forEach(content => {
        content.classList.remove('act');
        });
        button.classList.add('active')
        // 显示目标内容
        document.getElementById(targetId).classList.add('act');
    });
});